module.exports = __webpack_public_path__ + "static/media/coming_soon.f7ee184d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coming_soon.svg
// module id = 491
// module chunks = 0